module.exports = __webpack_public_path__ + "img/EventWinPage0919.d8dba86b.jpg";